export default {"src":"/_next/static/media/select-icon.571fdbd5.svg","height":24,"width":24};